import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PageShell({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#FDFBF7]">
      <Navbar />
      <main className="flex-1 px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto w-full py-10 lg:py-14">{children}</main>
      <Footer />
    </div>
  );
}
